import React from "react";
//import * as modalDataService from "./modalDataService";
// import { debug } from "../../utils";
// import { connect } from "react-redux";

function EnableSystemRemediationField({ value, onChange, disabled }) {

    // const onChange = (value) => { 
    //     hasEnabledSystemRemediation =value; 
    // }

    return (
        <div className="form-group">
            <div className="oct_check oct_check-v2 oct_check-v2-remediation modal-v2-remediation-toggle">
                <label className="oct_check-label oct_check-label-v2 oct_check-label-v2-remediation modal-v2-remediation-label">
                    <input type="checkbox" 
                            checked={!!value} 
                            disabled={disabled}
                            onChange={disabled ? null : () => onChange(!value)} />
                    <span className="oct_check-copy-v2 oct_check-copy-v2-remediation modal-v2-remediation-copy">
                        <span className="oct_check-title-v2 modal-v2-remediation-title">Enable Automatic System Remediation</span>
                        <span className="oct_check-help-v2 modal-v2-remediation-help">Automatically apply security fixes and compliance updates when violations are detected</span>
                    </span>
                </label>
            </div>
        </div>
    )

}

export default EnableSystemRemediationField;

// function mapStateToProps(state) {
//     debug("EnablePasswordField mapStateToProps", state);
//     const addDeviceModal = state.addDeviceModal;
//     return {
//         hasEnabledSystemRemediation: addDeviceModal.hasEnabledSystemRemediation || ''
//     }
// }

// export default connect(mapStateToProps)(EnableSystemRemediationField);
